import { HttpAdapter } from "../../main/adapters/HttpAdapter";
export class Loader {
    HttpAdapter = new HttpAdapter();
    baseUrlDataTimeseries = `${publicSettings.aws.baseUrls.dataTimeseries}/serie`;

    constructor() {}

    async setConstant({
        companyId,
        accountingId,
        base = { companyId, accountingId },
        sourceSerieId,
        value,
        scenarioId,
        serie = { _id }
    } = {}) {
        if (!companyId || !accountingId) return null;
        if (!sourceSerieId) return null;
        if (!value) return null;
        if (!scenarioId) return null;
        if (!serie) return null;
        try {
            const response = await this.HttpAdapter.call(
                `${this.baseUrlDataTimeseries}/constant`,
                {
                    companyId,
                    accountingId,
                    base,
                    sourceSerieId,
                    value,
                    scenarioId,
                    serie
                }
            );
            return response;
        } catch (error) {
            throw new Error(error?.message || "Erro ao salvar constante");
        }
    }
}
